import { gql } from 'graphql-tag';

export const getMemberCodes = gql`
  query getMemberCodes {
    getMemberCodes {
      id
      code
    }
  }
`;
